// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnBox[data-v-2f8e7ae0] {\n  display: flex;\n}\n.btn[data-v-2f8e7ae0] {\n  margin-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
